// import { useState } from "react";
// import {
//   fetchCategoriesTree,
//   createCategory,
//   updateCategory,
//   fetchOrganizerCategories,
//   deleteCategory as deleteCategoryApi,
// } from "../../../api/productCategory.api";

// export const useProductCategory = () => {
//   const [data, setData] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const loadCategories = async (company_id) => {
//     setLoading(true);
//     const res = await fetchCategoriesTree({ company_id });
//     setData(res.data?.data || []);
//     setLoading(false);
//   };

//   const loadCategoriesByOrganizer = async (company_id) => {
//   try {
//     const res = await fetchOrganizerCategories(company_id);
//     setCategories(res.data?.data || []);
//   } catch (error) {
//     console.error("Failed to load categories", error);
//     setCategories([]);
//   }
// };


//   const addCategory = (payload) => createCategory(payload);
//   const editCategory = (id, payload) => updateCategory(id, payload);
  
//   const deleteCategory = async (id, payload) => {
//     const res = await deleteCategoryApi(id, payload);
//     return res.data;
//   };



//   return {
//     data,
//     categories,
//     loading,
//     loadCategories,
//     loadCategoriesByOrganizer,
//     addCategory,
//     editCategory,
//     deleteCategory,
//   };
// };

import { useState } from "react";
import {
  fetchCategoriesTree,
  createCategory,
  updateCategory,
  fetchOrganizerCategories,
  deleteCategory as deleteCategoryApi,
} from "../../../api/productCategory.api";

export const useProductCategory = () => {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    totalCategories: 0,
    totalPages: 1,
  });

  // Updated to pass page, limit, and search parameters to the API
  const loadCategories = async (company_id, options = {}) => {
    if (!company_id) return;
    setLoading(true);
    try {
      const res = await fetchCategoriesTree({
        company_id,
        page: options.page || 1,
        limit: options.limit || 10,
        search: options.search || "",
      });

      const payload = res?.data || {};
      const list =
        payload.data?.categories ||
        payload.categories ||
        payload.data ||
        (Array.isArray(payload) ? payload : []);

      setData(list);

      // Store pagination metadata returned from backend
      setPaginationInfo({
        totalCategories:
          payload.pagination?.totalCategories || payload.total || list.length,
        totalPages: payload.pagination?.totalPages || payload.totalPages || 1,
      });
    } catch (error) {
      console.error("Failed to load category tree:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadCategoriesByOrganizer = async (company_id) => {
    try {
      const res = await fetchOrganizerCategories(company_id);
      setCategories(res.data?.data || []);
    } catch (error) {
      console.error("Failed to load categories", error);
      setCategories([]);
    }
  };

  const addCategory = (payload) => createCategory(payload);
  const editCategory = (id, payload) => updateCategory(id, payload);

  const deleteCategory = async (id, payload) => {
    const res = await deleteCategoryApi(id, payload);
    return res.data;
  };

  return {
    data,
    categories,
    loading,
    paginationInfo,
    loadCategories,
    loadCategoriesByOrganizer,
    addCategory,
    editCategory,
    deleteCategory,
  };
};